export default [
	{
		path: "/pros/upsells",
		exact: true,
		policy: "providerAuth",
		component: "Upsells",
		mui: true,
	},
];
